export interface Theme {
  name: string;
  label: string;
  variables: Record<string, string>;
}

// 清新航空主题：面向中学生，主色调为天空蓝 + 深海军蓝 + 薄荷绿
export const skyTheme: Theme = {
  name: 'sky',
  label: '清新航空',
  variables: {
    '--ink': '#1e293b',
    '--muted': '#64748b',
    '--deep': '#0f172a',
    '--card': '#ffffff',
    '--paper': '#f1f5f9',
    '--bg': '#e2e8f0',
    '--line': 'rgba(148, 163, 184, 0.28)',
    '--accent': '#0ea5e9',
    '--accent-dark': '#0284c7',
    '--green': '#10b981',
    '--green-soft': '#d1fae5',
    '--gold': '#f59e0b',
    '--red': '#ef4444',
    '--shadow': '0 18px 50px rgba(15, 23, 42, 0.10), 0 2px 10px rgba(15, 23, 42, 0.06)',
    // 地图专用色
    '--ocean': '#dbeafe',
    '--land': '#bfdbfe',
    '--land-stroke': 'rgba(59, 130, 246, 0.22)',
    '--country-border': 'rgba(30, 58, 138, 0.18)',
    '--airport-dot': '#64748b',
    '--airport-dot-stroke': 'transparent',
    '--range-circle': 'rgba(14, 165, 233, 0.42)',
    '--range-fill': 'rgba(14, 165, 233, 0.08)',
  },
};

// 保留原暖色主题作为可切换选项
export const warmTheme: Theme = {
  name: 'warm',
  label: '暖色羊皮纸',
  variables: {
    '--ink': '#323a21',
    '--muted': '#7c7359',
    '--deep': '#232f1c',
    '--card': '#faf5e8',
    '--paper': '#f3ecd9',
    '--bg': '#ece3cc',
    '--line': 'rgba(64, 54, 26, 0.16)',
    '--accent': '#a07c28',
    '--accent-dark': '#77591a',
    '--green': '#47794f',
    '--green-soft': '#e4ead2',
    '--gold': '#c19a3f',
    '--red': '#b0503c',
    '--shadow': '0 18px 50px rgba(74, 60, 28, 0.14), 0 2px 10px rgba(74, 60, 28, 0.08)',
    '--ocean': '#eae1c8',
    '--land': '#d8cdab',
    '--land-stroke': 'rgba(96, 76, 36, 0.26)',
    '--country-border': 'rgba(80, 62, 28, 0.42)',
    '--airport-dot': '#a0997a',
    '--airport-dot-stroke': 'transparent',
    '--range-circle': 'rgba(71, 121, 79, 0.55)',
    '--range-fill': 'rgba(71, 121, 79, 0.06)',
  },
};

export const themes: Record<string, Theme> = {
  sky: skyTheme,
  warm: warmTheme,
};

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  Object.entries(theme.variables).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
